import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SocialAistateListService {
    
  searchValue: string = '';
  page: number = 1;
}